/**
 * @generated SignedSource<<e7bcaf57a7de2a47db8ad5565cc28b24>>
 * @relayHash 876c3f80b40e500a1a19428c2d1c4745
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 7a0b9ad1d6d99de87344ee7490b9a2a703d95cd5259ed3d33fd96367692a7c4e

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { JiraSoftwareSummaryAppQuery } from './JiraSoftwareSummaryAppQuery.graphql';

const node: PreloadableConcreteRequest<JiraSoftwareSummaryAppQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "7a0b9ad1d6d99de87344ee7490b9a2a703d95cd5259ed3d33fd96367692a7c4e",
    "metadata": {},
    "name": "JiraSoftwareSummaryAppQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
